import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { SearchCriteriaModel } from 'src/common/stores/models';

import { FilterOptionModel, SortAndFilterModel } from 'src/common/components/common/search-form/fields/filter-types';

import { UitkButtonToggle, UitkButtonToggleGroup } from 'uitk-react-button-toggle';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';

import { FormFieldBinding } from 'src/common/components/common/search-form/fields/form-field-binding';

const ButtonTracked = ClickTracker(UitkButtonToggle);

const ButtonToggleGroup = ({
  model,
  modelKey,
  updateModel,
  sortAndFilterOptions,
}: {
  model: SearchCriteriaModel;
  modelKey: string;
  updateModel: any;
  sortAndFilterOptions: SortAndFilterModel;
}) => {
  const toggleChange = event => {
    const target = event.target;
    const { name, value } = target;
    const oldValue = model && model[modelKey];
    let selectedPropertyClasses = [];

    if (oldValue && oldValue.length > 0) {
      if (typeof oldValue === 'string') {
        selectedPropertyClasses = oldValue && oldValue.split(',');
      } else {
        selectedPropertyClasses = oldValue;
      }
    }

    if (typeof updateModel === 'function') {
      updateModel({
        target: {
          name,
          value: getSelectorValue(selectedPropertyClasses, value),
        },
      });
    }
  };

  const getSelectorValue = (selectedPropertyClasses: string[], value: string) => {
    if (selectedPropertyClasses.includes(value)) {
      selectedPropertyClasses = selectedPropertyClasses.filter(item => item !== value);
    } else {
      selectedPropertyClasses = [...selectedPropertyClasses, value];
    }

    if (selectedPropertyClasses.length > 0) {
      return selectedPropertyClasses.join(',');
    }

    return '';
  };

  const propertyClass = sortAndFilterOptions && sortAndFilterOptions[modelKey];
  const name = propertyClass && propertyClass.title;
  const options = propertyClass && propertyClass.options;
  const label = propertyClass && propertyClass.label;
  const subLabel = propertyClass && propertyClass.subLabel;
  const value = model && model[modelKey];

  if (!options || !options.length) {
    return null;
  }

  return (
    <UitkSpacing margin={{ blockstart: 'six' }}>
      <fieldset>
        <UitkSpacing margin={{ blockend: 'two' }}>
          <legend>
            <UitkHeading size={7} tag="h4">
              {label}
            </UitkHeading>
            {subLabel && (
              <UitkText theme="default" inline={true} weight="regular">
                {subLabel}
              </UitkText>
            )}
          </legend>
        </UitkSpacing>
        <UitkButtonToggleGroup className="property-class-input" wrapButtons={true}>
          {options.map(
            (option: FilterOptionModel, idx: number) =>
              option && (
                <ButtonTracked
                  key={`${name}-${idx}`}
                  id={`${name}-${idx}`}
                  name={name}
                  value={option.value}
                  aria-label={option.ariaLabel}
                  checked={value && value.includes(option.value)}
                  onChange={toggleChange}
                  labelText={option.label}
                  rfrr={`${name}.${option.value}`}
                  linkName={`${label} - ${option.label}`}
                />
              )
          )}
        </UitkButtonToggleGroup>
      </fieldset>
    </UitkSpacing>
  );
};
export const ButtonToggleGroupCheckbox = FormFieldBinding(ButtonToggleGroup);
